<template>
  <path pid="0" d="M18.33 17.24a1 1 0 001.42 0 6 6 0 000-8.49 1 1 0 00-1.42 1.42 4 4 0 010 5.65 1 1 0 000 1.42zM5.5 17h3.65l4.72 3.78A1 1 0 0015.5 20V6a1 1 0 00-1.63-.78L9.15 9H5.5a1 1 0 00-1 1v6a1 1 0 001 1zm1-6h3a1 1 0 00.62-.22l3.38-2.7v9.84l-3.38-2.7A1 1 0 009.5 15h-3z"/>
</template>
